<ng-container [ngSwitch]="column.type">
  <ng-container *ngSwitchCase="columnType.Text">
    <div
      *ngIf="!column.ellipsis"
      class="inline-block min-w-full"
      [ngClass]="column.position | mxColumnPosition : column.type"
    >
      {{
        value === null || value === "" || value === undefined
          ? ""
          : (column.prefix ? column.prefix : "") +
            value +
            (column.suffix ? column.suffix : "")
      }}
    </div>
    <div
      *ngIf="column.ellipsis"
      mxEllipsis
      class="inline-block min-w-full"
      [ngClass]="column.position | mxColumnPosition : column.type"
    >
      {{
        value === null || value === "" || value === undefined
          ? ""
          : (column.prefix ? column.prefix : "") +
            value +
            (column.suffix ? column.suffix : "")
      }}
    </div></ng-container
  >

  <ng-container *ngSwitchCase="columnType.Link">
    <div
      class="inline-block min-w-full"
      [ngClass]="column.position | mxColumnPosition : column.type"
    >
      <ng-container
        *ngIf="!(value === null || value === '' || value === undefined)"
      >
        <a [href]="value" target="_blank">{{ "Link" }}</a>
      </ng-container>
    </div>
    <div
      *ngIf="column.ellipsis"
      mxEllipsis
      class="inline-block min-w-full"
      [ngClass]="column.position | mxColumnPosition : column.type"
    >
      {{
        value === null || value === "" || value === undefined
          ? ""
          : (column.prefix ? column.prefix : "") +
            value +
            (column.suffix ? column.suffix : "")
      }}
    </div></ng-container
  >
  <ng-container *ngSwitchCase="columnType.Id">
    <div
      class="flex min-w-full"
      [ngClass]="column.position | mxColumnPosition : column.type"
    >
      {{
        (column.prefix ? column.prefix : "") +
          value +
          (column.suffix ? column.suffix : "")
      }}
    </div></ng-container
  >
  <ng-container *ngSwitchCase="columnType.Number">
    <div
      *ngIf="!column.editable"
      class="flex justify-content-center min-w-full"
      [ngClass]="column.position | mxColumnPosition : column.type"
    >
      {{
        value === null || value === "" || value === undefined
          ? ""
          : (column.prefix ? column.prefix : "") +
            (column.isPercentage
              ? value * 100
              : column.suffix.includes("Ft")
              ? value.toLocaleString("hu-HU")
              : value) +
            (column.suffix ? column.suffix : "")
      }}
    </div>
    <div
      *ngIf="column.editable"
      class="flex justify-content-center min-w-full"
      [ngClass]="column.position | mxColumnPosition : column.type"
    >
      <p-cellEditor>
        <ng-template pTemplate="input">
          <!-- <input
            pInputText
            [(ngModel)]="value"
            required
            [pKeyFilter]="'pint'"
            (change)="valueChange.emit(value)"
          /> -->
          <p-inputNumber
            [inputStyle]="{ 'max-width': column.width - 10 + 'px' }"
            inputId="integeronly"
            [(ngModel)]="value"
            (onInput)="
              valueChange.emit(
                $event.value === undefined || $event.value === null
                  ? 0
                  : $event.value
              )
            "
            [min]="0"
          ></p-inputNumber>
        </ng-template>
        <ng-template pTemplate="output">
          {{
            value === null || value === "" || value === undefined
              ? ""
              : (column.prefix ? column.prefix : "") +
                (column.isPercentage ? value * 100 : value) +
                (column.suffix ? column.suffix : "")
          }}
        </ng-template>
      </p-cellEditor>
    </div>
  </ng-container>
  <ng-container *ngSwitchCase="columnType.Boolean">
    <div
      class="flex w-full text-primary"
      [ngClass]="column.position | mxColumnPosition : column.type"
    >
      <i
        [class]="value ? 'fa fa-check-square fa-fw' : 'far fa-square fa-fw'"
      ></i>
    </div>
  </ng-container>
  <ng-container *ngSwitchCase="columnType.Enum">
    <div
      class="flex min-w-full"
      [ngClass]="column.position | mxColumnPosition : column.type"
    >
      {{ value | mxEnumAsString : column.enum : column.enumName | i18next }}
    </div></ng-container
  >
  <ng-container *ngSwitchCase="columnType.Date">
    <div
      class="flex min-w-full"
      [ngClass]="column.position | mxColumnPosition : column.type"
    >
      {{
        value === null || value === "" || value === undefined
          ? ""
          : (value | mxDateFormat : "YYYY.MM.DD.")
      }}
    </div></ng-container
  >
  <ng-container *ngSwitchCase="columnType.DateTime">
    <div
      class="flex min-w-full"
      [ngClass]="column.position | mxColumnPosition : column.type"
    >
      {{
        value === null || value === "" || value === undefined
          ? ""
          : (value | mxDateFormat : "YYYY.MM.DD. HH:mm")
      }}
    </div></ng-container
  >
  <ng-container *ngSwitchDefault>
    <div>
      {{
        value === null || value === "" || value === undefined
          ? ""
          : (column.prefix ? column.prefix : "") +
            value +
            (column.suffix ? column.suffix : "")
      }}
    </div>
  </ng-container>
</ng-container>
